import React from 'react';
import {Flex} from '@chakra-ui/react';
import {Credits} from '../Icons/Credits';

export const CreditCostTag = ({creditCost}: {creditCost: string | number}) => {
  return (
    <Flex
      alignItems="center"
      borderRadius="full"
      px="10px"
      py="5px"
      gap="2"
      w="fit-content"
      color="kred.400"
      bgColor="kred.50"
    >
      <Credits />
      {creditCost.toLocaleString()}
    </Flex>
  );
};
